import React, { useState } from "react";
import "./SoftwareSkill.scss";
import {skillsSection} from "../../portfolio";

export default function SoftwareSkill() {
  const [activeTab, setActiveTab] = useState("frontend");
  
  const tabs = [
    { id: "frontend", label: "Frontend" },
    { id: "backend", label: "Backend" },
    { id: "cloud", label: "Cloud" },
    { id: "ai", label: "AI" }
  ];

  const getActiveSkills = () => {
    return skillsSection.softwareSkills[activeTab] || [];
  };

  return (
    <div className="software-skills-container">
      <div className="skills-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`skill-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {getActiveSkills().map((skills, i) => {
            return (
              <li
                key={i}
                className="software-skill-inline"
                name={skills.skillName}
              >
                <i className={skills.fontAwesomeClassname}></i>
                <p>{skills.skillName}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
